import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { CurrentClient } from '../types';

export const getCurrentClient = async (): Promise<CurrentClient> => {
  const response = await fetchApi.get('/client/current') as CurrentClient;
  return response;
};

type QueryFnType = typeof getCurrentClient;

type UseConfigCurrentClientOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useCurrentClient = (config?: UseConfigCurrentClientOptions) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryKey: ["currentClient"],
    queryFn: () => getCurrentClient(),
  });